// Debug Version - Wholesale Minimum Quantity Script
// This version includes console logs to help debug issues

(function() {
  'use strict';
  
  const WHOLESALE_MINIMUM = 10;
  
  console.log('Wholesale script loaded');
  
  // Function to check if product has wholesale tag
  function hasWholesaleTag(productTags) {
    console.log('Checking tags:', productTags);
    if (!productTags) return false;
    const hasTag = productTags.toLowerCase().includes('wholesale');
    console.log('Has wholesale tag:', hasTag);
    return hasTag;
  }
  
  // Function to disable/enable add to cart button
  function toggleAddToCartButton(button, shouldDisable, quantity = 0) {
    console.log('Toggle button:', button, 'disable:', shouldDisable, 'quantity:', quantity);
    if (!button) {
      console.log('No button found');
      return;
    }
    
    if (shouldDisable) {
      button.disabled = true;
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');
      button.style.opacity = '0.5';
      button.style.cursor = 'not-allowed';
      button.style.pointerEvents = 'none';
      button.classList.add('disabled');
      
      // Update button text to show requirement
      const originalText = button.getAttribute('data-original-text') || button.innerHTML;
      if (!button.getAttribute('data-original-text')) {
        button.setAttribute('data-original-text', originalText);
      }
      button.innerHTML = `<span>Minimum ${WHOLESALE_MINIMUM} required (${quantity} selected)</span>`;
      console.log('Button disabled');
    } else {
      button.disabled = false;
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
      button.style.opacity = '';
      button.style.cursor = '';
      button.style.pointerEvents = '';
      button.classList.remove('disabled');
      
      // Restore original button text
      const originalText = button.getAttribute('data-original-text');
      if (originalText) {
        button.innerHTML = originalText;
      }
      console.log('Button enabled');
    }
  }
  
  // Function to disable Shopify Payment Button (Buy it now)
  function toggleShopifyPaymentButton(shouldDisable) {
    console.log('Toggling Shopify Payment Button, disable:', shouldDisable);
    
    // Try multiple approaches to disable the Buy it now button
    const paymentButtonContainer = document.querySelector('.shopify-payment-button');
    const buyNowButtons = document.querySelectorAll('.shopify-payment-button__button');
    
    if (paymentButtonContainer) {
      if (shouldDisable) {
        paymentButtonContainer.style.opacity = '0.5';
        paymentButtonContainer.style.pointerEvents = 'none';
        paymentButtonContainer.style.cursor = 'not-allowed';
        paymentButtonContainer.setAttribute('data-wholesale-disabled', 'true');
      } else {
        paymentButtonContainer.style.opacity = '';
        paymentButtonContainer.style.pointerEvents = '';
        paymentButtonContainer.style.cursor = '';
        paymentButtonContainer.removeAttribute('data-wholesale-disabled');
      }
    }
    
    // Also try to disable individual buttons
    buyNowButtons.forEach(button => {
      if (shouldDisable) {
        button.disabled = true;
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
        button.style.opacity = '0.5';
        button.style.pointerEvents = 'none';
      } else {
        button.disabled = false;
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
        button.style.opacity = '';
        button.style.pointerEvents = '';
      }
    });
    
    // Try to access shadow DOM buttons (for newer Shopify implementations)
    const shadowHosts = document.querySelectorAll('shopify-accelerated-checkout, shopify-buy-it-now-button');
    shadowHosts.forEach(host => {
      try {
        if (host.shadowRoot) {
          const shadowButtons = host.shadowRoot.querySelectorAll('button');
          shadowButtons.forEach(button => {
            if (shouldDisable) {
              button.disabled = true;
              button.setAttribute('disabled', 'disabled');
              button.setAttribute('aria-disabled', 'true');
            } else {
              button.disabled = false;
              button.removeAttribute('disabled');
              button.removeAttribute('aria-disabled');
            }
          });
        }
      } catch (e) {
        console.log('Could not access shadow DOM:', e);
      }
    });
  }
  
  // Function to show warning message
  function showWholesaleWarning(container, quantity) {
    console.log('Showing warning in container:', container);
    let warning = container.querySelector('.wholesale-warning');
    if (!warning) {
      warning = document.createElement('div');
      warning.className = 'wholesale-warning';
      warning.style.cssText = `
        color: #d32f2f !important;
        font-size: 14px !important;
        margin-top: 10px !important;
        padding: 8px 12px !important;
        background-color: #ffebee !important;
        border: 1px solid #ffcdd2 !important;
        border-radius: 4px !important;
        display: block !important;
      `;
      container.appendChild(warning);
    }
    
    const remaining = WHOLESALE_MINIMUM - quantity;
    warning.textContent = `Wholesale minimum: ${WHOLESALE_MINIMUM} items. Add ${remaining} more to proceed.`;
    warning.style.display = 'block';
  }
  
  // Function to hide warning message
  function hideWholesaleWarning(container) {
    const warning = container.querySelector('.wholesale-warning');
    if (warning) {
      warning.style.display = 'none';
    }
  }
  
  // Function to handle quantity change
  function handleQuantityChange(quantityInput, productTags) {
    console.log('Handling quantity change for tags:', productTags);
    if (!hasWholesaleTag(productTags)) {
      console.log('Not a wholesale product, skipping');
      return;
    }
    
    const quantity = parseInt(quantityInput.value) || 0;
    console.log('Current quantity:', quantity);
    
    // Try multiple selectors to find the form and button
    const productForm = quantityInput.closest('form') || 
                       quantityInput.closest('.product-form') ||
                       quantityInput.closest('.product__form') ||
                       quantityInput.closest('[data-product-form]');
    
    console.log('Found form:', productForm);
    
    // Try multiple selectors for add to cart button (your theme uses .product-form__submit)
    const addToCartButton = productForm ? 
      productForm.querySelector('.product-form__submit') ||
      productForm.querySelector('button[name="add"]') ||
      productForm.querySelector('.btn-product-add') ||
      productForm.querySelector('.product-form__cart-submit') ||
      productForm.querySelector('[type="submit"]') ||
      productForm.querySelector('button[data-add-to-cart]') ||
      productForm.querySelector('.add-to-cart') ||
      productForm.querySelector('button:last-of-type') : null;

    // Also find the "Buy it now" button
    const buyNowButton = productForm ? 
      productForm.querySelector('.shopify-payment-button__button') ||
      document.querySelector('.shopify-payment-button__button') : null;
    
    console.log('Found button:', addToCartButton);
    
    const container = quantityInput.closest('.product-form') || 
                     quantityInput.closest('.product') || 
                     quantityInput.closest('.product__info') ||
                     productForm ||
                     quantityInput.parentElement;
    
    console.log('Found container:', container);
    
    if (quantity < WHOLESALE_MINIMUM) {
      console.log('Quantity below minimum, disabling buttons');
      toggleAddToCartButton(addToCartButton, true, quantity);
      toggleShopifyPaymentButton(true);
      showWholesaleWarning(container, quantity);
    } else {
      console.log('Quantity meets minimum, enabling buttons');
      toggleAddToCartButton(addToCartButton, false, quantity);
      toggleShopifyPaymentButton(false);
      hideWholesaleWarning(container);
    }
  }
  
  // Initialize wholesale restrictions on page load
  function initWholesaleRestrictions() {
    console.log('Initializing wholesale restrictions');
    
    // Get product tags from multiple sources
    let productTags = '';
    
    // Try meta tag first
    const metaTags = document.querySelector('meta[name="product-tags"]');
    if (metaTags) {
      productTags = metaTags.getAttribute('content');
      console.log('Found tags from meta:', productTags);
    }
    
    // Try to find forms
    const productForms = document.querySelectorAll(
      'form[action*="/cart/add"], ' +
      '.product-form, ' +
      '.product__form, ' +
      '[data-product-form], ' +
      'form[data-type="add-to-cart-form"]'
    );
    
    console.log('Found forms:', productForms.length);
    
    productForms.forEach((form, index) => {
      console.log(`Processing form ${index + 1}:`, form);
      
      // Try to get tags from form data attribute if not found in meta
      if (!productTags) {
        productTags = form.getAttribute('data-product-tags') || 
                     form.getAttribute('data-tags') || '';
        console.log('Found tags from form:', productTags);
      }
      
      if (!hasWholesaleTag(productTags)) {
        console.log('Form does not have wholesale product, skipping');
        return;
      }
      
      // Try multiple selectors for quantity input (your theme uses .quantity__input)
      const quantityInput = form.querySelector('.quantity__input') ||
                           form.querySelector('input[name="quantity"]') ||
                           form.querySelector('.quantity-input') ||
                           form.querySelector('input[type="number"]') ||
                           form.querySelector('[data-quantity-input]') ||
                           form.querySelector('.js-qty__num') ||
                           form.querySelector('.product__quantity-input') ||
                           form.querySelector('.qty') ||
                           form.querySelector('input[id*="quantity"]') ||
                           form.querySelector('input[class*="quantity"]') ||
                           form.querySelector('quantity-input input') ||
                           form.querySelector('.quantity input') ||
                           document.querySelector('input[name="quantity"]') ||
                           document.querySelector('input[type="number"]');
      
      console.log('Found quantity input:', quantityInput);
      
      // Debug: Let's see what inputs are in this form
      const allInputs = form.querySelectorAll('input');
      console.log('All inputs in form:', allInputs);
      allInputs.forEach((input, i) => {
        console.log(`Input ${i}:`, input.name, input.type, input.className, input);
      });
      
      if (quantityInput) {
        // Set initial state - for wholesale products, start disabled
        const initialQuantity = parseInt(quantityInput.value) || 1;
        
        // For wholesale products, ensure quantity starts at 1 and buttons are disabled
        if (initialQuantity < WHOLESALE_MINIMUM) {
          quantityInput.value = Math.max(1, initialQuantity);
        }
        
        // Add event listeners
        quantityInput.addEventListener('input', () => {
          console.log('Quantity input changed');
          handleQuantityChange(quantityInput, productTags);
        });
        
        quantityInput.addEventListener('change', () => {
          console.log('Quantity change event');
          handleQuantityChange(quantityInput, productTags);
        });
        
        // Handle plus/minus buttons if they exist
        const plusButton = form.querySelector('.quantity-plus') ||
                          form.querySelector('.qty-plus') ||
                          form.querySelector('[data-quantity-plus]') ||
                          form.querySelector('.quantity__button--plus');
        
        const minusButton = form.querySelector('.quantity-minus') ||
                           form.querySelector('.qty-minus') ||
                           form.querySelector('[data-quantity-minus]') ||
                           form.querySelector('.quantity__button--minus');
        
        console.log('Found plus button:', plusButton);
        console.log('Found minus button:', minusButton);
        
        if (plusButton) {
          plusButton.addEventListener('click', () => {
            console.log('Plus button clicked');
            setTimeout(() => handleQuantityChange(quantityInput, productTags), 50);
          });
        }
        
        if (minusButton) {
          minusButton.addEventListener('click', () => {
            console.log('Minus button clicked');
            setTimeout(() => handleQuantityChange(quantityInput, productTags), 50);
          });
        }
        
        // Initial check
        console.log('Running initial check');
        handleQuantityChange(quantityInput, productTags);
      } else {
        console.log('No quantity input found in form');
      }
    });
    
    if (productForms.length === 0) {
      console.log('No product forms found on page');
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    console.log('DOM still loading, waiting...');
    document.addEventListener('DOMContentLoaded', () => {
      console.log('DOM loaded, initializing');
      initWholesaleRestrictions();
    });
  } else {
    console.log('DOM already loaded, initializing immediately');
    initWholesaleRestrictions();
  }
  
  // Re-initialize for AJAX loaded content
  document.addEventListener('shopify:section:load', () => {
    console.log('Shopify section loaded, re-initializing');
    initWholesaleRestrictions();
  });
  
  // Handle variant changes
  document.addEventListener('change', function(e) {
    if (e.target.matches('input[name="id"], select[name="id"]')) {
      console.log('Variant changed, re-initializing');
      setTimeout(initWholesaleRestrictions, 100);
    }
  });
  
})();